export const CONTACT_US_REQUEST = 'CONTACT_US_REQUEST';
export const CONTACT_US_REQUEST_SUCCESS = 'CONTACT_US_REQUEST_SUCCESS';
export const CONTACT_US_REQUEST_ERROR = 'CONTACT_US_REQUEST_ERROR';
